import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemConfigurationComponent } from './system-configuration.component';
import {
  AccomplishmentTargetEditorComponent
} from './accomplishment-target-editor/accomplishment-target-editor.component';
import { MainAuthGuard } from '../../../_shared/guards/main-auth-guard.service';
import { GeneralSystemConfigurationComponent } from './general-system-configuration/general-system-configuration.component';
import { SystemStatusEventEditorComponent } from './system-status-event-editor/system-status-event-editor.component';

const routes: Routes = [
  {
    path:             'system-configuration',
    canActivateChild: [MainAuthGuard],
    children:         [
      {
        path: '', component: SystemConfigurationComponent, children: [
          {path: '', redirectTo: 'general', pathMatch: 'full'},
          {
            path:      'general',
            component: GeneralSystemConfigurationComponent,
          },
          {
            path:      'status-events',
            component: SystemStatusEventEditorComponent
          },
          {
            path:      'targets',
            component: AccomplishmentTargetEditorComponent,
          }
        ]
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class SystemConfigurationRoutingModule {
}
